








"use strict";

const httpUtil = require("common-util/browser/http-util.js");
const XuxTableSupport = require("common-util/browser/xux-table-support.js");
const {WebStorageManager} = require("common-util/browser/webstorage-util.js");
const storage = new WebStorageManager();
const app = require("./app-common.js");
const order = require("./order.js");
const Util = require("./util");
const util = new Util();
const moment = require("moment");

app.init(true);

app.ready(() => {
    util.afterLoginApply(app, order, "device");
    util.logOutHeader(app);
    util.initSupportMenu(app);
    util.initLogoutMenu(app);

    let menuInstance = $("#utilmenu").xuxContextMenu({
        select(event, ui) {
            let selectType = ui.item.children("a").attr("href");
            if (selectType === "#install") {
                install(ui.context);
            }
            if (selectType === "#backup") {
                backup(ui.context);
            }
            if (selectType === "#delete") {
                restoreDeviceDelete(ui.context);
            }
        },
        beforeOpen() {
            window.document.activeElement.blur();
            return true;
        }
    });

    
    let instructTargetDeviceXuxTable = new XuxTableSupport({
        elem: $("#instruct-target-device-table"),
        l10n: app.l10n,
        columns: {
            pollable: {
                _hidden: true,
            },
            polling: {
                _hidden: true,
            },
            deviceId: {
                _hidden: true,
            },
            settingFormatVersion: {
                _hidden: true
            },
            settingDeviceVersion: {
                _hidden: true
            },
            countryCode: {
                _hidden: true
            },
            deviceName: {
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _localizationLabel: "device.label.name"
            },
            displayName: {
                _localizationLabel: "device.label.modelSerial",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            deviceComment: {
                _localizationLabel: "device.label.deviceInfo",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            action: {
                _localizationLabel: "com.label.blank",
                render(td, item) {
                    $("<span />").prop("class", "xux-icon xux-icon-ellipsisvert").xuxContextMenuTrigger({
                        menu: menuInstance,
                        context: item
                    }).appendTo(td);
                },
                _noQuery: true,
                width: "fitContent"
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "noPaging",
            dataFilter(item) {
                return item[0] && item[1];
            },
            fetch() {
                let url = instructTargetDeviceXuxTable.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/devices") + "?timestamp=" + Date.now());
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        orderId: storage.getItem("orderId")
                    }
                });
            }
        },
        xuxOptions: {
            columnResizable: true,
            pageNavigation: "none",
            autoLoad: false,
            sortOptions: {
                column: 1,
                order: "asc"
            },
            selectionUnit: "none"
        }});
    instructTargetDeviceXuxTable.init();

    
    let notInstructTargetDeviceXuxTable = new XuxTableSupport({
        elem: $("#not-instruct-target-device-table"),
        l10n: app.l10n,
        columns: {
            pollable: {
                _hidden: true,
            },
            polling: {
                _hidden: true,
            },
            deviceId: {
                _hidden: true,
            },
            deviceName: {
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _localizationLabel: "device.label.name"
            },
            displayName: {
                _localizationLabel: "device.label.modelSerial",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            deviceComment: {
                _localizationLabel: "device.label.deviceInfo",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            action: {
                _localizationLabel: "com.label.blank",
                render(td, item) {
                    $("<span />").prop("class", "xux-icon xux-icon-wastebasket")
                        .appendTo(td).click(() => {
                            window.document.activeElement.blur();
                            noRestoreDeviceDelete(item);
                        });
                },
                _noQuery: true,
                width: "fitContent"
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "noPaging",
            dataFilter(item) {
                return !item[0] || !item[1];
            },
            fetch() {
                let url = notInstructTargetDeviceXuxTable.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/devices") + "?timestamp=" + Date.now());
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        orderId: storage.getItem("orderId")
                    }
                });
            }
        },
        xuxOptions: {
            columnResizable: true,
            autoLoad: false,
            pageNavigation: "none",
            sortOptions: {
                column: 1,
                order: "asc"
            },
            selectionUnit: "none"
        }});
    notInstructTargetDeviceXuxTable.init();

    
    let settingXuxTable = new XuxTableSupport({
        elem: $("#setting-select"),
        l10n: app.l10n,
        columns: {
            settingId: {
                _hidden: true
            },
            origin: {
                _hidden: true
            },
            formatVersion: {
                _hidden: true
            },
            deviceVersion: {
                _hidden: true
            },
            countryCode: {
                _hidden: true
            },
            settingName: {
                _localizationLabel: "settings.label.name",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            createdAt: {
                _localizationLabel: "order.label.createDate",
                _defaultSort: true,
                contentEllipsis: true,
                defaultSortOrder: "desc",
                _sortByBeforeFormat: true,
                _formatter(value) {
                    return $.xux.formatDateTime(util.getDate(value), {seconds: true});
                }
            },
            settingComment: {
                _localizationLabel: "settings.label.memo",
                contentEllipsis: true,
                defaultSortOrder: "asc"
            },
            originName: {
                _localizationLabel: "settings.label.from",
                contentEllipsis: true,
                defaultSortOrder: "asc",
                _formatter(value, item) {
                    return item.get("origin") === "tool" ? window.localizedTextMessages.api.tool : value;
                }
            }
        },
        supportOptions: {
            enableBrowserfilter: true,
            cachePagingMethod: "noPaging",
            dataFilter(item) {
                let {
                    settingFormatVersion,
                    settingDeviceVersion,
                    countryCode
                } = installModalWindow.xuxModalWindow("option", "targetDevice");
                return util.checkFormatVersion(settingFormatVersion, item[2])
                    && util.checkDeviceVersion(settingDeviceVersion, item[3])
                    && util.checkCountryCode(countryCode, item[4]);
            },
            fetch() {
                let url = settingXuxTable.createQueryUrl(
                    httpUtil.getApiUrl("/p2p/settings") + "?timestamp=" + Date.now());
                return app.ajaxAuth({
                    url,
                    type: "get",
                    contentType: "application/json",
                    data: {
                        orderId: storage.getItem("orderId"),
                    }
                });
            }
        },
        xuxOptions: {
            selectionUnit: "row",
            selectionControl: "radio",
            selectionRemains: true,
            columnResizable: true,
            pageNavigation: "none",
            itemId: "settingId",
            autoLoad: false,
            select: checkSelection,
            unselect: checkSelection,
            afterRender: checkSelection,
            sortOptions: {
                column: 2,
                order: "desc"
            }
        }});
    settingXuxTable.init();

    function checkSelection() {
        let selectionNum = settingXuxTable.invoke("table").xuxTable("selection").length;
        $("#setting-select-yes").xuxButton(selectionNum > 0 ? "enable" : "disable");
    }
    
    let installModalWindow = util.modalWindow($("#setting-select-modalWindow"), {
        leadingMargin: false,
        type: "settings",
        width: "wide",
        height: "fit",
        open() {
            $("#setting-select-yes").xuxButton("disable");

            settingXuxTable.invoke("reload");

            $("#setting-select-cancel").unbind("click").click(() => {
                installModalWindow.xuxModalWindow("close");
            });

            $("#setting-select-yes").unbind("click").click(() => {
                backupSendModalWindow.find("form").xuxValidate();
                const settingId = settingXuxTable.invoke("selectedItemIds")[0];
                backupSendModalWindow.xuxModalWindow("option", "targetSettingId", settingId);
                backupSendModalWindow.xuxModalWindow("open");
            });
        },
        close() {
            settingXuxTable.invoke("clearSearch");
            settingXuxTable.invoke("resetAllSelections");
        }
    });
    
    let backupSendModalWindow = util.modalWindow($("#backup-send-modalWindow"), {
        leadingMargin: false,
        type: "settings",
        width: "wide",
        height: "auto",
        open() {
            backupSendModalWindow.find("form")[0].reset();

            if ($("#hour").children("option").length === 0) {
                util.setTimeDropdown($("#hour"), $("#minute"));
            }
            let select = backupSendModalWindow.find("#time-setting select");
            $("#date").xuxDateField("disable");
            select.attr("disabled", true).xuxDropdown("refresh");
            $("#backup-device-select-cancel").unbind("click").click(() => {
                backupSendModalWindow.xuxModalWindow("close");
            });
            backupSendModalWindow.find("input[name='time-setting-box']").change(() => {
                if ($("#time-setting-check input[type='radio']").eq(1).is(":checked")) {
                    $("#date").xuxDateField("enable");
                    select.removeAttr("disabled").xuxDropdown("refresh");
                    util.limitAssignationTime();
                } else {
                    $("#date").xuxDateField("disable");
                    select.attr("disabled", true).xuxDropdown("refresh");
                }
            });
            $("#backup-device-select-yes").unbind("click").click(() => {
                if (!backupSendModalWindow.find("form").xuxValidate("valid")) {
                    return;
                }

                let scheduledDatetime = "";
                if ($("#time-setting-check input[type='radio']").eq(1).is(":checked")) {
                    let assignationTime = moment($("#date").val() + " " + $("#hour").val() + ":" + $("#minute").val(), "YYYY-MM-DD HH:mm");
                    if (!util.checkDate(assignationTime)) {
                        return;
                    }
                    scheduledDatetime = assignationTime.format("YYYY-MM-DDTHH:mm:ssZ");
                }

                let categoryObj = $("#category-setting-check input[name='category-setting-box']").filter(":checked").attr("id");

                util.message({
                    flag: "2",
                    title: window.localizedTextMessages.instruction.title.send,
                    message: window.localizedTextMessages.instruction.warn.send,
                    yesBtnMsg: window.localizedTextMessages.com.btn.ok,
                    callbackObj: {
                        ok() {
                            const {deviceId} = installModalWindow.xuxModalWindow("option", "targetDevice");
                            const settingId = backupSendModalWindow.xuxModalWindow("option", "targetSettingId");
                            let operation = {
                                type: "restore",
                                settingId,
                                scheduledDatetime
                            };
                            if (categoryObj === "category-setting-address") {
                                operation.categories = ["AddressBook"];
                            }
                            return app.ajaxAuth({
                                url: httpUtil.getApiUrl("/p2p/jobs?orderId=" + storage.getItem("orderId")),
                                type: "post",
                                contentType: "application/json",
                                data: JSON.stringify({
                                    deviceId,
                                    operation
                                })
                            });
                        }
                    }
                }).then(isOk => {
                    if (isOk) {
                        backupSendModalWindow.xuxModalWindow("close");
                        installModalWindow.xuxModalWindow("close");
                        instructTargetDeviceXuxTable.invoke("reload");
                    }
                }).catch($.noop);
            });
        }
    });

    function install(context) {
        let targetDevice = {
            deviceId: context.get("deviceId"),
            settingFormatVersion: context.get("settingFormatVersion"),
            settingDeviceVersion: context.get("settingDeviceVersion"),
            countryCode: context._data.getOriginal("countryCode")
        };
        installModalWindow.xuxModalWindow("option", "targetDevice", targetDevice);
        installModalWindow.xuxModalWindow("open");
    }

    function backup(context) {
        
        util.message({
            flag: "2",
            title: window.localizedTextMessages.instruction.title.send,
            message: window.localizedTextMessages.instruction.warn.send,
            yesBtnMsg: window.localizedTextMessages.com.btn.send,
            callbackObj: {
                ok() {
                    app.ajaxAuth({
                        url: httpUtil.getApiUrl("/p2p/jobs?orderId=" + storage.getItem("orderId")),
                        type: "post",
                        contentType: "application/json",
                        data: JSON.stringify({
                            deviceId: context.get("deviceId"),
                            operation: {
                                type: "backup"
                            }
                        })
                    }).then(() => {
                        instructTargetDeviceXuxTable.invoke("reload");
                    });
                }
            }
        });
    }

    function restoreDeviceDelete(context) {
        let title = window.localizedTextMessages.device.title.deleteDevice;
        let message = window.localizedTextMessages.device.warn.deleteDevice;
        util.messageAlertTable({
            title,
            message,
            yesBtnMsg: window.localizedTextMessages.com.btn.delete,
            data: [{deviceName: context.get("deviceName"),
                    displayName: context.get("displayName")}],
            thead: ["device.label.name", "device.label.modelSerial"],
            tbody(data) {
                let tr = "<tr><td><div>" + util.text(data.deviceName) + "</div></td><td><div>" + util.text(data.displayName) + "</div></td></tr>";
                return tr;
            },
            yes() {
                doDeleteDevice(context.get("deviceId"));
            }
        });
    }
    function doDeleteDevice(deviceId) {
        return app.ajaxAuth({
            url: httpUtil.getApiUrl("/p2p/devices/" + deviceId + "?orderId=" + storage.getItem("orderId")),
            type: "delete",
            contentType: "application/json"
        }).then(() => {
            instructTargetDeviceXuxTable.invoke("reload");
        });
    }

    $("#body").xuxPage({
        width: "full",
        loginout: true,
        itemStates: ["", "selected", "", ""]
    });

    $("#orderid-update").click(() => {
        order.openOrderList(app);
    });
    $("a.date-select").xuxInfotip();

    $("#tabs").xuxTabbedSet({
        activate(event, target) {
            target.newPanel.find(".list-table").xuxDecoratedTable("reload");
        }
    });
    $("select").xuxDropdown({width: "narrowest"});
    $("#backup-send-modalWindow").find("section").xuxApplyBoxAndLayout({
        labelLayout: "leading",
        itemLayout: "vertical",
        getBoxOptions(options) {
            if ($(this).is("#time-setting")) {
                return $.extend({}, options, {
                    itemLayout: "horizontal"
                });
            }
            return options;
        }
    });

    $("#setting-select-modalWindow input[type='checkbox']").xuxCheckbox({labelLayout: "leading"});

    $("header").xuxHeader("utilityLinks")
        .xuxUtilityLinks("option", "user", app.session.userName);


    function noRestoreDeviceDelete(item) {
        let title = window.localizedTextMessages.device.title.deleteDevice;
        let message = window.localizedTextMessages.device.warn.deleteDevice;
        util.messageAlertTable({
            title,
            message,
            yesBtnMsg: window.localizedTextMessages.com.btn.delete,
            data: [{
                deviceName: item.get("deviceName"),
                displayName: item.get("displayName")
            }],
            thead: ["device.label.name", "device.label.modelSerial"],
            tbody(data) {
                let tr = "<tr><td><div>" + util.text(data.deviceName) + "</div></td><td><div>" + util.text(data.displayName) + "</div></td></tr>";
                return tr;
            },
            yes() {
                return app.ajaxAuth({
                    url: httpUtil.getApiUrl("/p2p/devices/" + item.get("deviceId") + "?orderId=" + storage.getItem("orderId")),
                    type: "delete",
                    contentType: "application/json"
                }).then(() => {
                    notInstructTargetDeviceXuxTable.invoke("reload");
                });
            }
        });
    }
    if (!app.session.tenant.isFXTenant || storage.getItem("orderId")) {
        instructTargetDeviceXuxTable.invoke("load");
    }

    $(".orderIdDiv").xuxApplyBoxAndLayout({
        labelLayout: "leading",
        contentEllipsis: true
    });

    if (!app.session.tenant.isFXTenant) {
        $(".orderIdDiv").xuxApplyBoxAndLayout().hide();
    }
});
